import styled from 'styled-components';
import {buttonFont, caption, colors, mediaQueries} from '@/theme/lib';
import { DownloadButtonProps } from '.';

export const StyledDownloadButton = styled.a<DownloadButtonProps>`
color: ${(props) => props.theme.colors.button.download.text};
background-color: ${(props) => props.theme.colors.button.download.bg};
border-radius: ${props => props.theme.config.buttonRadius};
border: 1px solid ${(props) => props.theme.colors.button.download.border};
&[target="_blank"]::after {
  background-image: url(/external-${(props) => props.theme.colors.button.download.file}.svg); 
}
display: inline-flex;
flex-flow: row nowrap;
align-items: center;
text-align: left;
padding: 8px 16px 7px 16px;
gap: 0.625rem;
* {
  background-color: inherit;
}
${mediaQueries.lg} {
  padding: 11px 28px 10px 24px;
}
.download__icon {
  display: flex;
  align-items: center;
  path {
    fill: ${(props) => props.theme.colors.button.download.icon};
  }
}
.download__text {
  line-height: 120%;
}
.download__title {
  ${buttonFont}
  text-transform: uppercase;
  ${mediaQueries.lg} {
    white-space: nowrap;
  }
}
.download__info {
  ${caption}
  color: ${colors.panther};
}
`;